import type { FeatureGridData } from '@/content/types';

export default function FeatureGrid(props: FeatureGridData) {
  return (
    <section className="container section-padding">
      {props.eyebrow && <div style={{ textAlign: 'center', fontSize: 14, color: 'var(--color-muted)' }}>{props.eyebrow}</div>}
      <h2 className="h-feature" style={{ textAlign: 'center', margin: '12px 0 40px' }}>{props.title}</h2>
      <div className="feature-grid">
        {props.cards.map((c, i) => (
          <div key={i} style={{ padding: 24, borderRadius: 16, background: c.dark ? '#000' : '#f5f5f5', color: c.dark ? '#fff' : '#000' }}>
            <div style={{ fontSize: 14, opacity: 0.6, marginBottom: 12 }}>{c.num}</div>
            <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>{c.title}</h3>
            <p style={{ fontSize: 14, opacity: 0.8 }}>{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
